<template>
    <div class="survey-note-view-practitioner">

        <!-- note -->
        <div class="review-time"
             v-if="surveyNote.type == 'awv' || surveyNote.review_minutes">
            <div v-html="$i18n.gt('MESSAGE_REPORT_REVIEW_SIGNATURE')"></div>
            <p class="note-minutes-spent">
                {{ $i18n.gt('HEADING_REPORT_TIME_SPENT') }}:
                {{ surveyNote.review_minutes }}
            </p>
        </div>

        <div class="review-time"
             v-if="surveyNote.type == 'ccm' || surveyNote.ccm_review_minutes">
            <span v-html="$i18n.gt('MESSAGE_REPORT_CCM_REVIEW_SIGNATURE')"></span>
            <template v-if="hasChronicCareTasksCompleted(surveyNote)">
                <p>
                    {{ $i18n.gt('HEADING_REPORT_TASKS_COMPLETED') }}:
                </p>
                <ul>
                    <template v-for="task in ccmTasks">
                        <li v-if="surveyNote[task.key]"
                            :key="task.key"
                            class="task-completed">
                            {{ $i18n.gt(task.labelKey) }}
                        </li>
                    </template>
                </ul>
            </template>

            <p class="note-minutes-spent">
                {{ $i18n.gt('HEADING_REPORT_CCM_TIME_SPENT') }}:
                {{ surveyNote.ccm_review_minutes }}
            </p>
        </div>

        <survey-note-view-patient :survey-note="surveyNote"></survey-note-view-patient>

    </div>
</template>

<script>

    import SurveyNoteViewPatient from './SurveyNoteViewPatient'
    import * as _ from 'lodash'

    /**
     * Displays details of a SurveyNote in a format appropriate for a Practitioner
     */
    export default {
        name: 'SurveyNoteViewPractitioner',
        components: { SurveyNoteViewPatient },
        props: {
            surveyNote: Object
        },
        data () {
            return {
                ccmTasks: [
                    { key: 'ccm_demographics', labelKey: 'LABEL_CCM_DEMOGRAPHICS' },
                    { key: 'ccm_problem_list', labelKey: 'LABEL_CCM_PROBLEM_LIST' },
                    { key: 'ccm_symptom_management', labelKey: 'LABEL_CCM_SYMPTOM_MANAGEMENT' },
                    { key: 'ccm_medication_use', labelKey: 'LABEL_CCM_MEDICATION_USE' },
                    { key: 'ccm_allergies', labelKey: 'LABEL_CCM_ALLERGIES' },
                    { key: 'ccm_clinical_summary', labelKey: 'LABEL_CCM_CLINICAL_SUMMARY' },
                    { key: 'ccm_goals', labelKey: 'LABEL_CCM_GOALS' },
                ]
            }
        },
        methods: {
            hasChronicCareTasksCompleted (surveyNote) {
                const completedTasks = _.filter(this.ccmTasks, (task) => {
                    return surveyNote[task.key]
                })
                return completedTasks.length > 0
            },
        },
    }
</script>

<style lang="scss">

    .survey-note-view-practitioner {
        .survey-note-view__note-text {
            white-space: pre-line;
            font-weight: normal;
        }

        .note-minutes-spent {
            text-transform: uppercase;
            font-style: normal;

        }

        .task-completed {
            /*list-style-type: none;*/
            margin-left: 30px;
        }
    }
</style>
